import { useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import ExecutiveShowcase from './components/ExecutiveShowcase';
import Portfolio from './components/Portfolio';
import Client from './components/Client';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const [theme, setTheme] = useState("dark");

  return (
    <div className={`${theme} min-h-screen bg-slate-950 text-slate-100 font-sans selection:bg-emerald-500 selection:text-slate-950`}>
      <Navbar setTheme={setTheme} theme={theme} />
      <main>
        <Home />
        <About />
        <ExecutiveShowcase />
        <Portfolio />
        <Client />
        <Blog />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
